import parsePhoneNumber, { CountryCode } from 'libphonenumber-js';

export function maskPhone(value: string, country?: string) {
  const numberValue = value?.replace(/[a-zA-Z]/gi, '');

  if (numberValue != null && numberValue !== '' && numberValue.length > 0) {
    const parseNumber =
      country != null
        ? parsePhoneNumber(numberValue.toString(), country as CountryCode)
        : parsePhoneNumber(numberValue.toString());

    if (parseNumber == null) return numberValue;

    const regex = new RegExp(
      `(?:${parseNumber.countryCallingCode.toString()})(.+)`
    );

    const internNumber = parseNumber.formatInternational();
    const formatted =
      internNumber.match(regex)?.[1]?.trim() ||
      (parseNumber.nationalNumber as string);

    return formatted;
  }

  return numberValue;
}

export const formatDate = [
  /\d/,
  /\d/,
  '/',
  /\d/,
  /\d/,
  '/',
  /\d/,
  /\d/,
  /\d/,
  /\d/,
];

export const maskCardNumber = [
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  ' ',
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  ' ',
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  ' ',
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
];

export const maskCvvCredit = [/\d/, /\d/, /\d/, /\d/];

export function mailMask(value: string) {
  return value != null ? value.replace(/\s+/g, '') : value;
}

export const maskCardExpiryDate = [/\d/, /\d/, '/', /\d/, /\d/];

export const obscureEmail = (email: string | undefined) => {
  if (email == null) return;

  try {
    const [name, domain] = email.split('@');

    return `${name.slice(0, 3)}${'*'.repeat(
      Math.max(name.length - 3, 0)
    )}@${domain}`;
  } catch {
    return;
  }
};
